export enum StepIndex {
  DADOS_GERAIS = 0,
  IDENTIFICACAO_ADOLESCENTE = 1,
  CIRCUNSTANCIAS = 2,
  NARRATIVAS = 3,
  RESUMO_OITIVA = 4,
}

export enum StepLabel {
  DADOS_GERAIS = 'DADOS GERAIS',
  IDENTIFICACAO_ADOLESCENTE = 'IDENTIFICAÇÃO DO ADOLESCENTE',
  CIRCUNSTANCIAS = 'CIRCUNSTÂNCIAS DO FATO/APREENSÃO',
  NARRATIVAS = 'NARRATIVAS',
  RESUMO_OITIVA = 'RESUMO DA OITIVA',
}

export enum StepPath {
  DADOS_GERAIS = 'dados-gerais',
  IDENTIFICACAO_ADOLESCENTE = 'identificacao',
  CIRCUNSTANCIAS = 'circunstancias',
  NARRATIVAS = 'narrativas',
  RESUMO_OITIVA = 'resumo',
}
